import {
    Button,
    VStack
} from '@chakra-ui/react';

import { AddIcon } from '@chakra-ui/icons';

import Const from '../Constants';

import { useEpicsStore } from '../Stores/EpicsStore';
import { useTasksStore } from '../Stores/TasksStore';

import SideBarButton from '../Atoms/SideBarButton';

const EpicsBar = ({
    auth
}) => {
  const epics = useEpicsStore((state) => state.epics);

  const addEpic = useEpicsStore((state) => state.addEpic);
  const deleteEpic = useEpicsStore((state) => state.deleteEpic);
  const updateEpic = useEpicsStore((state) => state.updateEpic);

  const currentEpic = useTasksStore((state) => state.currentEpic);
  const setCurrentEpic = useTasksStore((state) => state.setCurrentEpic);

  return (
    <VStack
        w={'180px'}
        minW={'180px'}
        maxW={'180px'}
        height={'100vh'}
        background={Const.Gray46}
        padding={Const.kPadding}
        spacing={Const.kSpacing}
        overflowY={'auto'} // Enables vertical scrolling
    >
      <VStack spacing={Const.kSpacing} w="100%">
      { !epics.empty && epics.map((epic, index) => (
        <SideBarButton
            key={epic.id}
            id={epic.id}
            current={currentEpic && epic.id === currentEpic.id}
            title={epic.title ? epic.title : 'New epic'}
            editable={true}
            background={epic.color}
            action={() => {
              if(epic.id === currentEpic?.id) {
                // If the epic is already selected, deselect it
                setCurrentEpic(auth, null);
              } else {
                setCurrentEpic(auth, epic);
              }
            }}
            menuEnabled={true}
            menuGroupEnabled={false}
            menuDeleteEnabled={true}
            menuDeleteAction={(id) => {
              deleteEpic(auth, id);
            }}
            menuRenameEnabled={true}
            menuRenameAction={(id, newTitle) => {
              updateEpic(auth, id, newTitle);
            }}
        />
      )) }
      </VStack>
      <Button
            leftIcon={<AddIcon boxSize={'10px'} />}
            size={Const.SM}
            minH={Const.kButtonHeight}
            width={'100%'}
            mt={Const.SpaceXS}
            background={Const.Gray46}
            color={Const.Green500}
            justifyContent={'flex-start'}
            _hover={{ background: Const.Gray69, color: Const.White }}
            onClick={ () => {
              addEpic(auth);
            }}
        >
          { 'Add epic' }
      </Button>
    </VStack>
  );
};

export default EpicsBar;
